import { Card, FormLayout, Layout, Select, TextField } from "@shopify/polaris";
import { CsI18n } from "../../shared/csI18n/csI18n";
import { CsNonValidation as NV, CsValidation as V, CsValidationForm } from "../../shared/csValidationForm";
import ChoiceHelper from "../../helpers/ChoiceHelper";
import Countries from "../../Countries";
import React from "react";

const CompanyLocation = (props) => {
  const {
    address1, address2, theState, postCode, city, country,
    phone, phoneError, fax, email,
    handleChange,
    validatorClass,
  } = props;

  return (
    <Layout.AnnotatedSection
      title={CsI18n.t("company.annotate.title.address")}
      description={CsI18n.t("company.annotate.desc.address")}>
      <Card sectioned>
        <CsValidationForm name={validatorClass} realtime={true}>
          <FormLayout>
            <FormLayout.Group>
              <V>
                <TextField label={CsI18n.t("Address 1")} onChange={handleChange('address1')} value={address1} />
                <V.Item rule="required" title={CsI18n.t("This field is required.")} />
              </V>
            </FormLayout.Group>
            <FormLayout.Group>
              <NV>
                <TextField label={CsI18n.t("Address 2")} onChange={handleChange('address2')} value={address2} />
              </NV>
            </FormLayout.Group>
            <FormLayout.Group>
              <NV>
                <TextField label={CsI18n.t("State")} onChange={handleChange('theState')} value={theState} />
              </NV>
              <V>
                <TextField label={CsI18n.t("Post code")} onChange={handleChange('postCode')} value={postCode} />
                <V.Item rule="required" title={CsI18n.t("This field is required.")} />
              </V>
            </FormLayout.Group>
            <FormLayout.Group>
              <V>
                <TextField label={CsI18n.t("City")} onChange={handleChange('city')} value={city} />
                <V.Item rule="required" title={CsI18n.t("This field is required.")} />
              </V>
              <NV>
                <Select
                  label={CsI18n.t("Country")}
                  options={ChoiceHelper.choices(Countries, false)}
                  value={country}
                  onChange={handleChange('country')}
                />
              </NV>
            </FormLayout.Group>
            <FormLayout.Group condensed>
              <V>
                <TextField label={CsI18n.t("Phone")} onChange={handleChange('phone')} value={phone}
                           error={phoneError ? phoneError : false} />
                <V.Item rule="required" title={CsI18n.t("This field is required.")} />
                <V.Item rule="phone"
                        title={`${CsI18n.t("Not a valid phone number.")} ${CsI18n.t('Example: {{phone}}', { phone: '+NN NNN NNNNNN' })}`} />
              </V>
              <NV>
                <TextField label={CsI18n.t("Fax")} onChange={handleChange('fax')} value={fax} />
              </NV>
              <V>
                <TextField label={CsI18n.t("Email")} onChange={handleChange('email')} value={email} />
                <V.Item rule="email" title={CsI18n.t("Not a valid email.")} />
              </V>
            </FormLayout.Group>
          </FormLayout>
        </CsValidationForm>
      </Card>
    </Layout.AnnotatedSection>
  )
};

export default CompanyLocation;